export const INIT = 'init'
export const UPLOAD_DOCUMENT = 'uploadDocument'
